import { http } from '@/http'

export default {
  list(data, params) { return http.post('/positions/list', data, { params }) },
  listAll()          { return http.get('/positions') },
  get(id)            { return http.get(`/positions/${id}`) },
  save(data)         { return http.post('/positions', data) },
  update(id, data)   { return http.put(`/positions/${id}`, data) },
  changeStatus(id, status) { return http.put(`/positions/${id}/status`, null, { params: { status } }) },
  download(data)     { return http.post('/positions/xlsx', data, { responseType: 'blob' }) },
}
